import React, { useEffect } from "react";
import { useLoading } from '../LoadingContext';

const CookiePolicyPage = () => {
  const { toggleLoading } = useLoading();

  useEffect(() => {
    // DOM manipuláció a komponens betöltésekor
    const body = document.body;
    const wrapper = document.getElementById("page-content");

    // wrapper?.classList.add("page-content-public"); // optional if needed
    body.classList.add("dark-theme");
    toggleLoading(false);

    // Cleanup – optional, ha el akarod távolítani kilépéskor
    return () => {
      body.classList.remove("dark-theme");
    };
  }, []);

  return (
    <div className="container" style={{ marginTop: 20 }}>
      <div className="row">
        <h2>Cookie Policy</h2>
      </div>
      <div className="row">
        <h2>
          <span id="A_weboldal_cookie_tájékoztatója"></span>
          <span>A weboldal cookie tájékoztatója</span>
        </h2>
      </div>

      <div className="row" style={{ marginTop: 10 }}>
        <p>
          Az alábbi cookiekat szükséges hozzáadnod a weboldal működéshez
          elengedhetetlen cookiek listájához:
        </p>
      </div>

      {/* TECHNIKAI COOKIE TÁBLA */}
      <div className="row" style={{ marginTop: 10 }}>
        <table className="wikitable">
          <thead>
            <tr className="wikitable-tr">
              <th>Cookie neve</th>
              <th>Cookie leírása és célja</th>
              <th>Szolgáltató</th>
              <th>Mennyi ideig tárolódik az eszközödön?</th>
            </tr>
          </thead>
          <tbody>
            {/* 1. sor */}
            <tr className="wikitable-tr">
              <td>ba_vid</td>
              <td>
                Célja a Barion Smart Gateway szolgáltatás során a bankkártyás csalások kiszűrése...
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Barion Payment Zrt.</a>
              </td>
              <td>Utolsó frissüléstől számított 1,5 évig.</td>
            </tr>

            {/* További cookie-k... */}
            <tr className="wikitable-tr">
              <td>ba_vid.xxx</td>
              <td>
                Célja a Barion Smart Gateway szolgáltatás során a bankkártyás csalások kiszűrése...
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Barion Payment Zrt.</a>
              </td>
              <td>Utolsó frissüléstől számított 1,5 évig.</td>
            </tr>

            <tr className="wikitable-tr">
              <td>ba_sid</td>
              <td>
                Célja a munkameneted azonosítása honlapokon átívelően.
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Barion Payment Zrt.</a>
              </td>
              <td>30 percig</td>
            </tr>

            <tr className="wikitable-tr">
              <td>ba_sid.xxx</td>
              <td>
                Célja a session azonosítása az adott honlapon belül.
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Barion Payment Zrt.</a>
              </td>
              <td>30 percig</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="row">
        <h2 style={{ marginTop: 20}}>
          <span id="stat_anal_cookie"></span>
          <span>Statisztikai / analitikai sütik</span>
        </h2>
        <p style={{ marginBottom: 0}}>
          Segítenek megérteni, hogyan használják a látogatók az oldalt. Ezek a sütik névtelen adatokat gyűjtenek, és hozzájárulnak a weboldal fejlesztéséhez.
        </p>
      </div>

      {/* Analitika marketing*/}
      <div className="row" style={{ marginTop: 10 }}>
        <table className="wikitable">
          <thead>
            <tr className="wikitable-tr">
              <th>Cookie neve</th>
              <th>Cookie leírása és célja</th>
            </tr>
          </thead>
          <tbody>
            <tr className="wikitable-tr">
              <td>_ga</td>
              <td>
                A Google Analytics által használt süti, amely egyedi azonosítót rendel a látogatóhoz. Segít a webhely használatának elemzésében.
              </td>
            </tr>

            <tr className="wikitable-tr">
              <td>_ga_BN7300GTE2</td>
              <td>
                A Google Analytics része. Pontosabb statisztikai adatokat gyűjt az adott webhely aldomainjein különböző részein belül.
              </td>
            </tr>
            <tr className="wikitable-tr">
              <td>_ga_4HZRLWK9JJ</td>
              <td>
                A Google Analytics része. Pontosabb statisztikai adatokat gyűjt az adott webhely aldomainjein különböző részein belül.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="row">
        <h2 style={{ marginTop: 20}}>
          <span id="marketing_cookie"></span>
          <span>Marketing célú sütik</span>
        </h2>
        <p style={{ marginBottom: 0}}>
          Ezek a sütik a látogatók viselkedését követik a weboldalon, és lehetővé teszik személyre szabott hirdetések megjelenítését külső platformokon.
        </p>
      </div>

      {/* Analitika marketing*/}
      <div className="row" style={{ marginTop: 10 }}>
        <table className="wikitable">
          <thead>
            <tr className="wikitable-tr">
              <th>Cookie neve</th>
              <th>Cookie leírása és célja</th>
            </tr>
          </thead>
          <tbody>
            <tr className="wikitable-tr">
              <td>_fbp</td>
              <td>
                A Facebook által beállított süti, amely lehetővé teszi, hogy az oldal látogatóiról adatokat gyűjtsenek hirdetési célokra, például remarketinghez.
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      {/* Kiegészítő szövegek */}
      <div className="row" style={{ marginTop: 10 }}>
        <p>
          Ha a cookie élettartama az utolsó frissüléstől definiált...
        </p>
        <p>
          A következő cookiekat kell hozzáadni a marketing cookie listához...
        </p>
      </div>

      {/* MARKETING COOKIE TÁBLA */}
      <div className="row" style={{ marginTop: 10 }}>
        <table className="wikitable">
          <thead>
            <tr className="wikitable-tr">
              <th>Cookie neve</th>
              <th>Cookie leírása és célja</th>
              <th>Szolgáltató</th>
              <th>Mennyi ideig tárolódik az eszközödön?</th>
            </tr>
          </thead>
          <tbody>
            <tr className="wikitable-tr">
              <td>BarionMarketingConsent.xxx</td>
              <td>
                Tárolja, hogy hozzájárultál-e a személyre szabott hirdetésekhez...
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Barion Payment Zrt.</a>
              </td>
              <td>Utolsó frissüléstől számított 1,5 évig</td>
            </tr>

            <tr className="wikitable-tr">
              <td>Media and advertiser partners' cookie</td>
              <td>
                Célja különböző rendszerek azonosítóinak szinkronizálása.
              </td>
              <td>
                <a rel="nofollow" href="https://www.barion.com/en/privacy-notice/">Lásd adatkezelési tájékoztató</a>
              </td>
              <td>
                További részletek:{" "}
                <a rel="nofollow" href="https://docs.barion.com/Barion_Pixel_hozz%C3%A1j%C3%A1rul%C3%A1skezel%C3%A9si_k%C3%B6vetelm%C3%A9nyek#Adatfeldolgozó_partnerek">
                  itt
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Utolsó szakasz */}
      <div className="row" style={{ marginTop: 10 }}>
        <p>
          A marketing cookie elhelyezése a látogató hozzájárulását igényli...
        </p>
      </div>

      <div className="row" style={{ marginTop: 10 }}>
        <h2>Adatfeldolgozó partnerek</h2>
      </div>
      <div className="row" style={{ marginTop: 10 }}>
        <p>mint felhasználó a Barion Marketing Cloud-hoz és a Barion Pixelhez</p>
      </div>
      <div className="row" style={{ marginBottom: 10 }}>
        <ul>
          <li>DataMe Kft. 1118 Budapest, Ugron Gábor utca 35.</li>
        </ul>
      </div>
      <div className="row" style={{ marginTop: 10 }}>
        <h2>Hogyan kezelheti a sütibeállításokat?</h2>
      </div>
      <div className="row" style={{ marginTop: 10, marginBottom: 20 }}>
        <p>

          A weboldal első látogatásakor lehetőséget biztosítunk arra, hogy elfogadja vagy testre szabja a sütik használatát. A hozzájárulási beállításait bármikor módosíthatja a böngészője sütikezelési lehetőségei segítségével.

          További információ
          Az adatkezelésről és az Ön jogairól részletesen az Adatkezelési tájékoztatóban olvashat.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
